import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';

export interface IBaseDetails {
	file: number;
	folder: number;
	content: number;
	size: number;
}

export interface IDetails extends IBaseDetails {}

export interface IReadonlyDetails extends IBaseDetails {}

export type Details = ReadonlyRecord<IReadonlyDetails>;

export const DetailsFactory = Record<IReadonlyDetails>({
	file: 0,
	folder: 0,
	content: 0,
	size: 0
});

export const DetailsFactoryFromJS = (data: IDetails): Details => DetailsFactory(data);
